// import data from './sampledata.json';
import BootstrapTable from "react-bootstrap-table-next";
import React from "react";
import NavBar from "components/SideBar/SideBar2";
import { Button, TextField } from "@material-ui/core";
import { Modal } from "react-responsive-modal";
import { useState } from "react";
import ItemBootTable from "./ItemBootTable";
import "./styles.css";
const Index = () => {
  const [openItem, setopenItem] = useState(false);
  const [itemData, setItemdata] = useState(0);
  const itemFormatter = (cell, row, rowIndex, formatExtraData) => {
    // console.log(row)
    return (
      <div>
        <Button
          onClick={() => onItemClick(cell, row, rowIndex, formatExtraData)}
          style={{
            backgroundColor: "cadetblue",
            position: "inherit",
            fontSize: "10px",
          }}
        >
          <span style={{ color: "#ffffffdb" }}>Items</span>
        </Button>
      </div>
    );
  };
  const onItemClick = (cell, row, rowIndex, formatExtraData) => {
    setopenItem(true);
    console.log("ROw on item click is " + JSON.stringify(row));
  };
  const products = [
    {
      Gstin: 1,
    },
  ];
  const columns = [
    {
      dataField: "Gstin",
      text: "Gstin",
      submitItemTable: {
        text: "Status",
        dataField: "hello",
      },
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "dty",
      text: "Document Type",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "inv_type",
      text: "Invoice Type",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "dst",
      text: "Document Status",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "spl_ty",
      text: "Supply Type",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "ctpy",
      text: "Type of counterparty",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "rtpy",
      text: "Type of Registered Dealer",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "ctin",
      text: "GSTIN/ UIN of counterparty",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "cname",
      text: "Name of counterparty",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "nt_num",
      text: "Note/ Voucher Number",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "nt_dt",
      text: "Note/ Voucher Date",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "inum",
      text: "Invoice/Document Number",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "idt",
      text: "Invoice/Document Date",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "sbnum",
      text: "Bill of entry/ Import report Number",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "sbdt",
      text: "Bill of entry/ Import report Date",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "sbpcode",
      text: "Bill of entry/ Import report Port Code",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "rsn",
      text: "Reason for Issuing Note",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "p_gst",
      text: "Does this Dr./ Cr. Note pertain to pre-GST regime?",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "omon",
      text: "Original Month",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "ont_num",
      text: "Original Note/Voucher Number",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "ont_dt",
      text: "Original Note/Voucher Date",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "oinum",
      text: "Original Invoice Number",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "oidt",
      text: "Original Invoice Date",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "octin",
      text: "Original GSTIN/UIN Number",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "val",
      text: "Total Invoice Value/Note Value",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "pos",
      text: "Place of supply",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },
    {
      dataField: "rchrg",
      text: "Whether reverse charge is applicable",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";

        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
    },

    {
      dataField: "item",
      text: "Item Level data",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const color = "#4f2d7f";
        return { fontFamily, fontSize, fontWeight };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
      },
      formatter: itemFormatter,
    },
  ];
  const onCloseModal = () => {
    setopenItem(false);
  };
  return (
    <div>
      <NavBar currentPage="Upload GST Return" module="anx1"></NavBar>
      <div style={{ width: "75vw", overflow: "auto" }}>
        <BootstrapTable
          id="r2aTable"
          keyField="Gstin"
          data={products}
          columns={columns}
        />
        <Modal
          open={openItem}
          onClose={onCloseModal}
          center
          classNames={{
            overlay: "itemOverlay",
            modal: "itemModal",
          }}
        >
          <div>
            <ItemBootTable itemData={itemData} />
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Index;
